// Queries and mutations unique to the Packs module
import { gql } from 'apollo-boost';

export const DELETE_TEMPLATE_CATEG_MUTATION = gql`
mutation deleteBookTemplateCategory($bookTemplateCategoryId: ID!) {
    deleteBookTemplateCategory(bookTemplateCategoryId: $bookTemplateCategoryId) {
        deleted
        errors
    }
}
`;

export const HIDE_TEMPLATE_CATEG_MUTATION = gql`
mutation hideBookTemplateCategory($bookTemplateCategoryId: ID!, $hidden: Boolean!) {
    hideBookTemplateCategory(bookTemplateCategoryId: $bookTemplateCategoryId, hidden: $hidden) {
        bookTemplateCategory {
            id
            name
            hidden
        }
        errors
    }
}
`;